<script>
import formatCurrency from "@utils/format-currency";
import formatPaymentMethod from "@utils/format-payment-method";
import formatOrderPrepaid from "@utils/format-order-prepaid";
import { authComputed, merchantComputed } from "@store/helpers";
import { prepaidFormatUsedTimes } from "@utils/ipetbooking-prepaid";
import { orderAtmInfoList, orderIsCanPay, orderVaccInfoList,orderParamsList } from "@utils/ipetbooking-order";
import formatPrice from "@utils/format-price";
import { conditionList } from "@utils/is-condition";

export default {
  components: {
    OrderPaymentButton: () => import("@components/Order/OrderPaymentButton"),
  },
  props: {
    orderItem: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    hasExtrafieldsByOrder() {
      const orderExtrafields = this.orderItem.byOrderExtrafields || {};

      return !!Object.keys(orderExtrafields)[0];
    },
    hasExtrafields() {
      return this.hasExtrafieldsByOrder
    },
    orderList() {
      // const paramsList = (item) => {
      //   const defaultItem = {
      //     text: item.total < 0
      //       ? `- NT$ ${formatCurrency(Math.abs(item.total))}`
      //       : `NT$ ${formatCurrency(item.total)}`,
      //     class: item.total < 0
      //       ? 'text-danger'
      //       : '',
      //     textClass: 'font-number',
      //   };
      //   switch(item.type) {
      //     case '+':
      //       return {
      //         ...defaultItem,
      //         title: `加價`,
      //         shortTitle: `加價`,
      //       };
      //     case '-':
      //       return {
      //         ...defaultItem,
      //         title: `減價`,
      //         shortTitle: `減價`,
      //       };
      //     case '%':
      //       return {
      //         ...defaultItem,
      //         title: `折扣(${item.description}%)`,
      //         shortTitle: `折扣(${item.description}%)`,
      //       };
      //     default:
      //       return {
      //         ...defaultItem
      //       }
      //   }
      // }
      // const orderBillingParamsList = () => {
      //   return this.orderItem.params.map((item)=> {
      //     return paramsList(item)
      //   })
      // }
      const paramsList = (typeList) => {
        return orderParamsList({
          typeList: typeList,
          params: this.orderItem.params,
        })
      };
     
      const  orderBillingParamsList = paramsList(['+', '-', '%','coupon','deposit'])
      
      console.log(orderBillingParamsList)
      return conditionList([
        {
          title: ` <i class="fontello ${this.$globalIsDingBeauty ? 'fontello-db-lipstick fs-xl' : 'fontello-paw'} fa-fw mr-2 text-primary"></i>${this.orderItem.prepaid.title}x1 (可抵用<span title="${this.orderItem.times}">${prepaidFormatUsedTimes(this.orderItem.times)}</span>次)
          `,
          text: `${
              this.orderItem.params[0].levelDiscount > 0 ? 
              `<span class="text-gray-2">
                會員價：NT$ ${formatCurrency(this.orderItem.params[0].total)}
              </span>
              <br>
              <span class="font-number text-decoration-line-through fs-2sm text-gray-2">售價：NT$ ${formatCurrency(this.orderItem.params[0].price)}</span>
              `
              : 
              this.orderItem.prepaid.price}
            `,
          textClass: 'font-number',
        },
        {
          type: 'hr',
        },
        {
          title: '小計',
          text: `${formatPrice(this.orderItem.params[0].total)}`,
          textClass: 'font-number',
        },
        // {
        //   title: `折扣${this.orderItem.discountValue}${this.orderItem.discountType === '%' ? '%' : ''}`,
        //   text: `-NT$ ${formatCurrency(this.orderItem.discountAmount)}`,
        //   class: 'text-danger',
        //   textClass: 'font-number',
        //   condition: () => {
        //     return !!this.orderItem.discountAmount && !!this.orderItem.discountType && !!this.orderItem.discountValue
        //   },
        // },
        ...orderBillingParamsList,
        // {
        //   title: '儲值金付款',
        //   text: `-NT$ ${formatCurrency(this.orderItem.depositDiscountAmount)}`,
        //   class: 'text-danger',
        //   textClass: 'font-number',
        //   condition: () => {
        //     return this.orderItem.paymentMethod === 'Deposit'
        //   },
        // },
        {
          title: `<span class="text-${formatOrderPrepaid(this.orderItem.status).color} fw-semi-bold">${formatOrderPrepaid(this.orderItem.status).title}</span><br><span class="text-gray-2 fs-2sm">${formatOrderPrepaid(this.orderItem.status, this.orderItem).paidInfo}</span>`,
          text:  `${formatPrice(this.orderItem.price)}`,
          class: 'align-items-end mt-2',
          textClass: `font-number fs-2xl fw-semi-bold text-${formatOrderPrepaid(this.orderItem.status).infoColor}`,
        }
      ]) 
    },
    vaccInfoList() {
      return orderVaccInfoList({ ...this.orderItem, unpaid: this.orderItem.price })
    },
    atmInfoList() {
      return orderAtmInfoList({ ...this.orderItem, unpaid: this.orderItem.price })
    },
  },
  methods: {
    formatCurrency,
    formatPaymentMethod,
    formatOrderPrepaid,
    orderIsCanPay,
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.detailOrderItemReservation">
    <BaseList
      :data-list="orderList"
      type="order"
    />
    <template v-if="orderItem.paymentMethod === 'Vacc' && !!vaccInfoList[0]">
      <hr>
      <BaseList
        :data-list="vaccInfoList"
        type="info"
      />
    </template>
    <template v-if="orderItem.paymentMethod === 'Atm' && !!atmInfoList[0]">
      <hr>
      <BaseList
        :data-list="atmInfoList"
        type="info"
      />
    </template>
    <OrderPaymentButton
      :order-item="orderItem"
      type="prepaid"
      button-class="mt-5"
    />
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.detailOrderItemReservation {
  padding: 1.875rem;
  border: 1px solid rgba($color-primary, 0.5);

  :global {
    .detailOrderItemReservation {
      &__no {
        padding: 1rem;
        margin-bottom: 2rem;
        font-size: 0.875rem;
        background: rgba($color-blue, 0.3);
        border: 1px solid $color-primary;
      }
    }
  }
}
</style>
